export const INSURANCE_PRODUCT_TYPE_OPTIONS = [
  'Commercial',
  'Commercial (ACA)',
  'EPO',
  'HMO',
  'Medicaid',
  'Medicaid (MMA)',
  'Medicaid (Special Population)',
  'Medicare Advantage',
  'Medicare Advantage (D-SNP)',
  'Medicare Advantage (HMO)',
  'Medicare Advantage (PPO)',
  'POS',
  'PPO',
  'Tiered HMO/PPO',
]

export const INSURANCE_LOB_CATEGORY_OPTIONS = ['Commercial', 'MA', 'Medicaid']
